import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MigrateFeedState } from './migrate_feed.types';

export const initialMigrateFeedState: MigrateFeedState = {
    loadingMigration: false,
    error: null,
    statusToMigrate: null,
    newEmail: '',
};

const migrateFeedSlice = createSlice({
    name: 'migrate_feed',
    initialState: initialMigrateFeedState,
    reducers: {
        setStatusToMigrate: (state, action: PayloadAction<string>) => {
            state.statusToMigrate = action.payload;
        },
        setNewEmail: (state, action: PayloadAction<string>) => {
            state.newEmail = action.payload;
        },
        setLoadingMigration: (state, action: PayloadAction<boolean>) => {
            state.loadingMigration = action.payload;
        },
    },
});

export const { setStatusToMigrate, setNewEmail, setLoadingMigration } = migrateFeedSlice.actions;

export const selectMigrateFeed = (state: { migrate_feed: MigrateFeedState }) => state.migrate_feed;

export default migrateFeedSlice.reducer;
